module.exports = __webpack_public_path__ + "static/media/playalong-bg-demo_start.8f45d92b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/playalong-bg-demo_start.jpg
// module id = ./src/assets/images/playalong-bg-demo_start.jpg
// module chunks = 0